import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69b00515886e1000149c6e6a_1793633970245_2a8ec9d3/myriad_digital_tech_centre/src/components/ui/ChunkErrorHandler.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b00515886e1000149c6e6a_1793633970245_2a8ec9d3/myriad_digital_tech_centre/src/styles/index.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b00515886e1000149c6e6a_1793633970245_2a8ec9d3/myriad_digital_tech_centre/src/styles/tailwind.css");
